<template>
  <div class="brand-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-9 brand-title-container">
          <h3>LA-007</h3>
        </div>
        <div class="col-12 col-md-3 brand-search-container">
          <div class="input-group custom-form">
            <input
              type="text"
              style="padding: 10px;border-radius: 3px;float:right;position:relative;flex:1 1 auto"
              placeholder="Enter Serial Number"
              v-model="searchInput"
              @keypress="handleSearchKeypress($event)"
            />
            <div class="input-group-append">
              <button class="btn custom-btn" type="button" @click="emitSearchEvent">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LicenseCheckerHeader',
  data: () => ({
    searchInput: ''
  }),
  methods: {
    handleSearchKeypress (event) {
      if (event.key === 'Enter' || event.which === 13) {
        this.emitSearchEvent()
      }
    },
    emitSearchEvent () {
      const { searchInput } = this
      if (searchInput !== '') {
        this.$emit('search', searchInput)
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../styles/variables.scss';

.brand-header {
  min-height: 75px;
  height: 75px;
  width: 100%;
  background-color: $primary;
  padding-left: 15px;
  padding-right: 15px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  color: $white;
  z-index: 1000;
}

.brand-title-container {
  display: flex;
  align-items: center;
}

.brand-title-container h3 {
  margin: 0;
}

.brand-search-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.custom-form input,
.custom-form input:focus,
.custom-form input:active {
  background-color: transparent;
  color: $white;
  box-shadow: none;
  border: 1px solid $white;
}

.custom-form .custom-btn,
.custom-form .custom-btn:focus,
.custom-form .custom-btn:active,
.custom-form .custom-btn:hover {
  background-color: transparent;
  color: $white;
  border: 1px solid $white;
  box-shadow: none;
  border-radius: 5px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/license-checker/license-checker-header.vue